import { render, staticRenderFns } from "./brandTable.vue?vue&type=template&id=da110fc6&"
import script from "./brandTable.vue?vue&type=script&lang=js&"
export * from "./brandTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports